import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection } from 'angularfire2/firestore';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface Aula {
  id?: string;
  moduloId: string;
  title: string;
  description?: string;
  teacher?: string;
  type: string;
  start: any;
  end: any;
  content?: any;
  prova: any;
  links?:any
}

@Injectable({
  providedIn: 'root'
})
export class AulasService {

  private aulasCollection: AngularFirestoreCollection<Aula>;
  private aulasFiltered: AngularFirestoreCollection<Aula>;
  private aulas: Observable<Aula[]>;
  private aulasFilter: Observable<Aula[]>;
 
  constructor(public db: AngularFirestore) { 
    this.aulasCollection = db.collection<Aula>('aulas');

    this.aulas = this.aulasCollection.snapshotChanges().pipe(
      map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data();
          const id = a.payload.doc.id;
          return { id, ...data };
        });
      })
    );

  }

  getAll(){
    return this.aulas
  }

  getAulas(moduloId){
    this.aulasFiltered = this.db.collection<Aula>('aulas', ref => ref.where('moduloId', '==', moduloId));

    this.aulasFilter =  this.aulasFiltered.snapshotChanges().pipe(
      map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data();
          const id = a.payload.doc.id;
          return { id, ...data };
        });
      })
    );

    return this.aulasFilter
  }

  getAval(id){
    return this.db.collection('Provas').doc(id).snapshotChanges().pipe(
      map(a => {
        return {id: a.payload.id, ...a.payload.data()}
      })
    )
  }

  getAvalQuestions(id){
    return this.db.collection('Provas').doc(id).collection('questions').snapshotChanges().pipe(
      map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data();
          const id = a.payload.doc.id;
          return { id, ...data };
        });
      })
    )
  }

  getAvalQuest(id){
    return this.db.collection('questions').doc(id).valueChanges()
  }

  getAula(id){
    return this.aulasCollection.doc<Aula>(id).valueChanges();
  }

  updateAula(aula: Aula, id: string) {
    return this.aulasCollection.doc(id).update(aula);
  }
 
  addAula(aula: Aula) {
    return this.aulasCollection.add(aula)
  }
 
  removeAula(id) {
    return this.aulasCollection.doc(id).delete();
  }

  saveAval(data){
    return this.db.collection('results').add(data)
  }

  getAvals(alunoId){
    return this.db.collection('results', ref => ref.where('alunoId', '==', alunoId)).valueChanges()
  }

}
